import React from 'react';
import { BrowserRouter } from 'react-router-dom';
import LayoutRoutes from './routes/LayoutRoutes';

const App = () => {
  return (
    <BrowserRouter>
      <LayoutRoutes />
    </BrowserRouter>
  );
};

export default App;
